import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 0E37E506-8AD8-42C7-87E4-F8A2AEE03972
 * name volume-medium
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-medium.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const VolumeMediumIcon = createSvgIcon(<><path d="M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z" /></>, 'VolumeMediumIcon');
export default VolumeMediumIcon